import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material'
import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function ViewBarComponent({title,setSelectedPDFUrl,url}) {
  return (
    <div>
        <Box sx={{ textAlign: 'center', padding: 4 }}>
    
            <Grid container spacing={4} justifyContent="center">

            <Grid item style={{ width:'100%',textAlign:'left' }} >
                <Card >
                <CardContent>
                    <Typography 
                    component="div">
                    <span style={{ fontFamily: 'Arial, sans-serif',fontSize:18,fontWeight:500 }}>{title}</span>
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                    
                    </Typography>
                    <Button
                    variant="contained"
                    onClick={()=>setSelectedPDFUrl(url)}
                    style={{ backgroundColor:'white',color:'#990000'   }}
                    startIcon={<VisibilityIcon />}
                    fullWidth
                        
                    >
                    View
                    </Button>
                </CardContent>
                </Card>
            </Grid>

        </Grid>
        </Box>
    </div>
  )
}
